import React, { Component } from 'react';
import SaSdk from 'sa-sdk-javascript';
import { Flex, Checkbox, Button, Modal, Toast } from 'antd-mobile';
import $proxy from '@/utils/proxy';
import { onWrapTouchStart, format3Number } from '@/utils/utils';
import { RssushRepaymentMethodApi } from '@/api/index';
import './index.scss';

const CheckboxItem = Checkbox.CheckboxItem;
const { apiRazorpayGet, apiRazorpayCreate, apiRazorpayCancel } = RssushRepaymentMethodApi;
class RepaymentMethodRsrush extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // 付款列表
      payList: [
        { value: 'Razorpay', name: 'Razorpay' },
      ],
      payChecked: 'Razorpay',
      payLoading: false,
      appData: {},
      modalShow: false,
      localApp: 'rsrush',
      payData: null, // 获取还款内容，可能上一次已经创建连接，已创建链接仅需重新发起上一次支付
    }
  }

  handleRadioChange(item) {
    this.setState({
      payChecked: item.value
    })
  }
  handlePayClick() {
    if (this.state.payLoading) return;
    this.setState({ payLoading: true })

    const { payData, appData } = this.state
    if (payData) {
      // 链接金额和用户还款金额相同，且状态没有过期，则可以发起支付
      // 金额相等 app传过来是String、后端传过来是Number
      if ((payData.status === 0) && (+payData.amount === +appData.amount)) {
        window.open(payData.shortUrl || '', '_top');
        // window.location.replace(payData.shortUrl || '');
      } else {
        // 状态已过期 取消上一个支付，然后再创建新的支付
        this.cancelPay();
      }
    } else {
      this.cretePay();
    }
  }
  sensorsInit() {
    SaSdk.init({
      server_url: process.env.NODE_ENV === 'production' ? 
        'https://salasa.xcreditech.com/sa?project=production' : 'https://salasa.xcreditech.com/sa',
      heatmap: {
        // 是否开启点击图，default 表示开启，
        // 自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
        clickmap: 'default',
        // 是否开启触达注意力图，not_collect 表示关闭，
        // 不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
        scroll_notice_map: 'default'
      },
      show_log: process.env.NODE_ENV === 'development',
    });
    SaSdk.registerPage({
      pagename: 'h5_repayment_methods',
      appName: 'RsRush',
      current_url: window.location.href,
    })
    SaSdk.quick('autoTrack');
    SaSdk.track('h5_repayment_methods');
  }
  getPay() {
    const { loanId, token } = this.state.appData;
    let data = {};
    $proxy({
      url: `${ apiRazorpayGet }`,
      rootUrl: `${ this.state.localApp }`,
      method: 'post',
      notify: false,
      data: { loanId, },
      headers: {
        'Accept-Language': 'en',
        Authorization: token,
      },
    }).then(res => {
      // Toast.info(JSON.stringify(res), 10)
      data = res;
    }).catch((err) => {
      data = null;
    }).finally(() => {
      this.setState({ payData: data });
    })
  }
  cretePay() {
    const {
      loanId, token, amount, counponAmount, counponCode,
      counponId, appVersion, appId,
    } = this.state.appData;

    $proxy({
      url: `${ apiRazorpayCreate }`,
      rootUrl: `${ this.state.localApp }`,
      data: {
        amount,
        appVersion,
        couponAmount: counponAmount,
        couponCode: counponCode,
        userCouponId: counponId,
        loanId,
      },
      headers: {
        'Accept-Language': 'en',
        App_version: appVersion,
        Authorization: token,
        App_id: appId
      },
    }).then(res => {
      window.open(res.shortUrl || '', '_top');
      // window.location.replace(res.shortUrl || '');
    }).catch(err => {
      Toast.fail(err.msg || 'Pay Failed', 3);
      this.setState({ payLoading: false });
    })
  }
  cancelPay() {
    const {
      loanId, token, counponCode, counponId, appVersion, appId
    } = this.state.appData;
    $proxy({
      url: `${ apiRazorpayCancel }`,
      rootUrl: `${ this.state.localApp }`,
      headers: {
        'Accept-Language': 'en',
        Authorization: token,
        App_version: appVersion,
        App_id: appId
      },
      data: {
        appVersion: appVersion,
        couponCode: counponCode,
        userCouponId: counponId,
        loanId,
        invoiceId: this.state.payData.invoiceId,
      },
    }).then(() => {
      this.cretePay();
    }).catch(err => {
      Toast.fail(err.msg || 'Pay Failed', 3);
      this.setState({ payLoading: false });
    })
  }

  getAppData() {
    if (window.payInfo) {
      try {
        const o = window.payInfo.getPayInfo();
        this.initAppData(o ? JSON.parse(o) : {})
      } catch (err) {
        console.log('get data error', err);
      }
    } else {
      this.setState({
        modalShow: true,
        payLoading: true,
      })
      // const data = '{"amount":"1015.00","appId":"cash.rupee.credit.loan.india","appVersion":"1.2.2","counponAmount":"","counponCode":"","counponId":"","dueDate":"2020-12-04","loanId":"L027a9f9eff0e1000","token":"72967741F6DD0A2A65293443848B9DF5B37ACEA9C35B598E3B80F5E37DC391E1"}';
      // this.initAppData(data ? JSON.parse(data) : null)
    }
  }
  initAppData(info) {
    const {
      amount, // 付款金额
      loanId,
      token, // 头部token 不允许付款之后(跳到第三方的链接去支付)返回该页面 所以该参数仅作为js变量使用
    } = info;
    if(!token || !loanId || !amount) {
      this.setState({
        modalShow: true,
        payLoading: true,
      })
      return;
    }

    this.setState({
      appData: Object.assign({}, this.state.appData, {
        ...info,
        token: 'Bearer ' + info.token,
      }),
    })
  }
  handleCloseModal() {
    window.payInfo && window.payInfo.close();
  }

  componentDidMount() {
    document.title = 'RsRush Pro Repayment';
    this.getAppData();

    setTimeout(() => {
      this.sensorsInit();
      this.getPay();
    }, 80)
  }

  render() {
    const { payList, payChecked, payLoading, modalShow, appData } = this.state
    const payComponents = payList.map(pay => {
      return (
        <div className="pay-item"
          key={ pay.value }
          onClick={() => this.handleRadioChange(pay) }
        >
          <CheckboxItem
            onChange={() => this.handleRadioChange(pay) }
            checked={ pay.value === payChecked }
          >
            { pay.name }
          </CheckboxItem>
        </div>
      )
    })
    return (
      // RMRsrush = RepaymentMethodRsrush
      <Flex className="RMRsrush" direction="column">
        {/* 付款后点击浏览器返回页面失败，此处弹框提示并直接调用app关闭webview */}
        <Modal
          className="RMRsrush-modal"
          visible={ modalShow }
          transparent
          maskClosable={false}
          onClose={ this.handleCloseModal }
          title="Get data exception"
          footer={[{ text: 'Back', onPress: () => { this.handleCloseModal() } }]}
          wrapProps={{ onTouchStart: onWrapTouchStart }}
        >
          Get data exception, return to the previous page to operate again ?
        </Modal>

        <Flex.Item className="header">
          <h3>Repay Amount</h3>
          <h2 className="header-amount">
            <span className="unit">₹</span> { format3Number(appData.amount) }
          </h2>
          
          <label>Due on { appData.dueDate || '--' }</label>
        </Flex.Item>
        <Flex.Item className="body">
          { payComponents }
        </Flex.Item>
        <Flex.Item className="footer">
          <Button type="primary" size="large"
            onClick={ () => this.handlePayClick() }
            loading={payLoading}
            disabled={payLoading}
          >Repay Now</Button>

          { payLoading }
        </Flex.Item>
      </Flex>
    )
  }
}

export default RepaymentMethodRsrush
